import * as log from "loglevel";

class LogService {
    constructor() {
        // set logging level
        const url = window.location.href;
        const isDev = url.indexOf("useMocks=true") !== -1 || url.indexOf("debug=true") !== -1;
        if (isDev) {
            log.setLevel("debug");
        } else {
            log.setLevel("error");
        }
    }

    static getLogger = () => {
        return log;
    };
}

export default LogService;
